$(function() {
    [...document.querySelectorAll('.testimonials-pagination a')].forEach(e => {
        e.addEventListener('click', function(ev) {
            if (!this.classList.contains('collapsed')) {
                // Prevents testimonials collapse from completely closing
                ev.stopPropagation();
            }
        });
    });
});